@if (showButton) {
  <div [hidden]="showCalendar">
    <div class="d-flex flex-column align-items-start position-relative">
      <button
        id="my-event-button"
        class="add-result border-0 d-flex align-items-center justify-content-center p-2 cursor-pointer bg-primary text-white"
        (click)="toggleShowCalendarOption()"
      >
        <div class="d-flex align-items-center">
          <span class="icon material-icons currency-icons pe-1" role="img">{{ googleIconName1 }}</span>
          <span class="fw-bold font-size-14">{{ 'fgbcl.add.to.calendar' | translate: { fgbdefault: 'Add to Calendar' } }}</span>
        </div>
      </button>
    </div>
  </div>
}
